import {AfterViewInit, Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GlobalFunction} from '../../core/global_function';
import {ActivatedRoute, Router} from '@angular/router';
import {Global_DB} from '../../core/global_db';

declare var $: any;

@Component({
    selector: 'onefile',
    templateUrl: 'onefile.component.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => OnefileComponent),
        multi: true
    }]
})
export class OnefileComponent implements OnInit, ControlValueAccessor, AfterViewInit {
    // ControlValueAccessor props
    private propagateTouch = () => { };
    private propagateChange = (_: any) => { };
    @Input()
    data: any;

    @Input()
    set value(vl: any) {
        this._value = vl;
    }
    get value() {
        return this._value;
    }

    @Input()
    set link(vl: any) {
        this._link = vl;
        this.setLinkImage();
    }
    _link: string;

    @Input()
    set link_api(vl: any) {
        this._link_api = vl;
    }
    @Input()
    set document_name(vl: any) {
      this.documentName = vl;
    }

    documentName: string;
    _link_api: string;
    link_file: string;
    file_name: string;
    file_size: any;

    @Input()
    set attribute_api(vl: any) {
        this._attribute_api = vl;
    }
    _attribute_api: {};

    @ViewChild('input') _input: any;
    @ViewChild('upload') _upload: any;

    @Input()
    cssImport: any;

    @Input()
    width: any;

    @Input()
    disabled: any;

    @Input()
    options: any;

    @Output()
    valueChanged = new EventEmitter<any>();

    constructor(private route: ActivatedRoute, private router: Router, private db: Global_DB) { }

    ngOnInit() { }

    ngAfterViewInit() {
    }
    _value: any = '';
    writeValue(value: any): void {
        if (value === undefined || value === null) {
            this._value = '';
        } else {
            this._value = value;
        }
        this.setLinkImage();
    }
    setLinkImage() {
        if (this._value && !GlobalFunction.EmptyObject(this._value)) {
            // this.link_file = this._link + this._value;
            console.log(this._value);
            this.link_file = this._value.url;
            let originFileNameArr = this.link_file.split("/");
            let originFileName = originFileNameArr[originFileNameArr.length - 1];
            this.file_name = decodeURIComponent(originFileName);
            this.file_size = this._value.size;
        } else {
            this.link_file = '';
        }

    }
    private sendModelChange(val: any) {
        this.propagateChange(this.getValueValue(val));
    }

    private getValueValue(val: any) {
        let result: any = val;
        if (!val) {
            return val;
        }
        return result;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.propagateTouch = fn;
    }

    click_broswer() {
        this._upload.nativeElement.click();
    }
    delete_file() {
        var that = this;
        that._value = '';
        that.link_file = '';
        that.file_name= '';
        that.file_size = '';
        that.sendModelChange(that._value);
        that.valueChanged.emit({
            type: 'change'
        });
    }
    obj_message: any;
    limit = 20 * 1024 * 1024;
    check_file(file) {
        return true;
        // var a = file.type.split('/');
        // var name = file.name.toLowerCase();
        // var flag = false;
        // if(name.match(/\.(rar|zip)$/gi)) {
        //     flag = true;
        // } else {
        //     if(a.length == 2 && GlobalFunction.contains(a[1],['plain', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet','msword','pdf', 'vnd.ms-excel', 'x-zip-compressed', 'vnd.openxmlformats-officedocument.wordprocessingml.document'])) {
        //         flag = true;
        //     }
        // }
        // return flag;
    }
    errorUpload;
    upload_image(event) {
        this.errorUpload = '';
        var that = this;
        var file = event.target.files[0];
        if (this.check_file(file)) {
            if (file.size <= this.limit) {
                let reader = new FileReader();
                reader.onloadend = function () {
                  var a = reader.result.split('base64,');
                  var base64 = a[1];

                  let url = "Content-Type:"+ file.type +"\r\nContent-Disposition:attachment;filename=\""+ file.name +"\"\r\nContent-Transfer-Encoding: base64\r\n\r\n" + base64;
                  if (!that.documentName) {
                    that.documentName = file.name;
                  }
                  that.db.post(that._link_api, { name: that.documentName ,url: url, size: file.size }).then(r => {
                    if (r && !r.error) {
                      that.link_file = r.url;
                      that._value = r.file_id;
                      that.file_name  = file.name;
                      that.file_size = file.size;
                      that.sendModelChange(that._value);
                      event.target.value = '';
                      that.valueChanged.emit({
                        type: 'change'
                      });
                    } else {
                      event.target.value = '';
                      that.errorUpload = r.error;
                    }
                  })
                };
                reader.readAsDataURL(file);
            } else {
                event.target.value = '';
                this.errorUpload = 'File is too large. Limit for the file \'' +file.name+'\' ' + (this.limit / (1024 * 1024)) + 'MB.';
            }
        } else {
            event.target.value = '';
            this.errorUpload = 'Your file upload not format txt,pdf,doc,xls,xlsx,docx,rtf.';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/common/component/onefile/onefile.component.ts